// Premium is active only if the flag is on AND it has not expired.
// Manual admin grants have no premiumUntil, so they never expire.
export function isPremiumActive(data, now = new Date()) {
  if (!data || !data.isPremium) return false;
  if (!data.premiumUntil) return true;
  const until = new Date(data.premiumUntil);
  return Number.isNaN(until.getTime()) ? false : until > now;
}
